const news = [{
  id: 3,
    img: 'new_1.png',
    title: '项目案例 现场直击:北京北街家园',
    time: '2024-09-02',
    content: '生活水平的提高和生活节奏的加快，人们对自身居住的环境也有了更高的要求。安全，又要方便快捷的停车管理方式，是现代物业的首选。北京北街家园选择车易付产品，为他们的停车出行带来更多方便。'
},
{
  id:2,
  img: 'new_2.png',
  title: '汽车打蜡也要审时度势',
  time: '2024-08-07',
  content: '首先，新车不要随便打蜡。因为新车在出厂时，厂家已经给汽车本身的漆层上了一层保护蜡，如果过早给新车打蜡，反而会把新车表面的原装蜡除掉。一般情况下，新车行驶半年左右再打蜡。<br>&nbsp;&nbsp;之后，打蜡时间可根据车辆行驶的环境、停放场所、车身触摸感的不同。自己有车库停放，且又多在路况良好行驶的车辆，每3-4个月打一次蜡；露天停放的车辆，多风吹雨淋，最好每2-3个月打一次蜡。<br>打蜡前， 要先用专用洗车剂或清水清洗车身外表的灰尘和泥土， 将车体擦拭干后再上蜡。 但是清水里千万不能加洗衣粉、 洗洁精和肥皂水等洗涤剂。 因为这些洗涤剂含有的氯化钠成分会侵蚀车身漆层、 蜡膜和橡胶件， 使车漆失去光泽、 橡胶件老化。<br>车身打蜡后， 对于车灯、 车牌、 车门和行李舱等处的缝隙中残留的车蜡， 要用棉签轻轻的将蜡垢彻底清除干净， 保持完美的打蜡效果。'
},
  { 
    id:1,
    img: 'bg2.png',
    title: '限速新规要来了，看你的这些行为还会不会扣分？',
    time: '2024-07-07',
    content: '经常跑高速的车主，经常会遇到模糊不清，或者忽高忽低式的限速，搞得人反应不及，而被罚。究其原因，还是很多限速标志不规范不合理导致的。因此，交通运输部近期发布了《公路限速标志设计规范》，将于今年11月1日生效，大量不合理的限速标志将会面临拆除。<br>同时， 多地也推出了一些关于高速限速的改革， 包括提高限速值、 对部分轻微超速违章行为免扣分罚款。<br>这几种超速不再扣分罚款<br>公安部交通管理局还出台了《关于规范查处机动车违反限速规定交通违法行为的指导意见》，统一了超速处罚标准。<br>以下几种轻微交通违法行为， 未造成后果的， 由公安交通管理部门予以警告， 不再扣分罚款：<br>1、 限速低于60km / h的公路上超过规定车速50 % 以下的；<br>2、 驾驶中型以上客货车、 校车、 危化品运输车在高速公路、 城市快速路以外的道路上超过规定车速10 % 以下的;<br> 3、 驾驶中型以上客货车、 校车、 危化品运输车以外的机动车超过规定车速10 % 以下的；<br>4、 驾驶机动车在高速公路上行驶低于规定车速20 % 以下的。'
  }
]
export default news